import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Icon, Image } from '@elparking/components'
import messages from './messages'
import {injectIntl} from 'react-intl'
import {
    ParkingCardParkingTypeLegend,
    ParkingCardParkingTypeLegendOfficial,
    ParkingCardParkingTypeLegendMowizTruck,
} from './layout'

import { PARKING_TYPE_AIRPORT, PARKING_TYPE_VIAT, PARKING_TYPE_SHARED } from 'commons/js/constants'

const MowizTruckOfficial = ({ intl }) =>
    <ParkingCardParkingTypeLegendMowizTruck>
        <Image
          located={false}
          height='1em'
          width='2em'
          marginBottom='-1px'
          alt={ intl.formatMessage(messages.mowizTruck) }
          src='/images/icon_mowiz.svg' />
        <span>{ intl.formatMessage(messages.mowizTruck) }</span>
    </ParkingCardParkingTypeLegendMowizTruck>

MowizTruckOfficial.propTypes = {
    intl: PropTypes.object,
}

class ParkingLegend extends React.PureComponent {
    static propTypes = {
        intl: PropTypes.object,
        parking: PropTypes.shape({
            typeString: PropTypes.string,
            isOfficial: PropTypes.bool,
            isMowizTruck: PropTypes.bool,
            onlyTrucksAllowed: PropTypes.bool,
        }),
    }

    render () {
        const { intl, parking } = this.props
        const { typeString: type, isMowizTruck, isOfficial, onlyTrucksAllowed } = parking

        if (onlyTrucksAllowed) {
            return (<div>
                <ParkingCardParkingTypeLegend>
                    <Flex heigth='1em' mb='-1px'>
                        <Box mr='0.5em'><Icon type='signal-truck-fill' color='white' /></Box>
                        <span>{ intl.formatMessage(messages.trucks) }</span>
                    </Flex>
                </ParkingCardParkingTypeLegend>
                { isMowizTruck && <MowizTruckOfficial intl={intl} />}
            </div>)
        }

        if (type === PARKING_TYPE_AIRPORT) {
            return (<div>
                <ParkingCardParkingTypeLegend>
                    <Image
                      located={false}
                      marginRight='0.5em'
                      height='1em'
                      marginBottom='-1px'
                      alt={ intl.formatMessage(messages.airport) }
                      src='/images/parking/icon_airport.svg' />
                    <span>{ intl.formatMessage(messages.airport) }</span>
                </ParkingCardParkingTypeLegend>
                { isOfficial &&
                    <ParkingCardParkingTypeLegendOfficial>
                        <Image
                          marginRight='0.5em'
                          height='1em'
                          marginBottom='-1px'
                          alt={ intl.formatMessage(messages.airportOfficial) }
                          src='/images/parking/icon_official.svg' />
                        <span>{ intl.formatMessage(messages.airportOfficial) }</span>
                    </ParkingCardParkingTypeLegendOfficial>
                }
                { isMowizTruck && <MowizTruckOfficial intl={intl} />}
            </div>)
        }

        if (isMowizTruck) {
            return <MowizTruckOfficial intl={intl} />
        }

        if (type === PARKING_TYPE_VIAT) {
            return (
                <ParkingCardParkingTypeLegend>
                    <Icon type='viat-logo' color='white' /> Via-T
                </ParkingCardParkingTypeLegend>
            )
        }

        if (type === PARKING_TYPE_SHARED) {
            return (
                <ParkingCardParkingTypeLegend>
                    { intl.formatMessage(messages.particular) }
                </ParkingCardParkingTypeLegend>
            )
        }

        return null
    }
}

export default injectIntl(ParkingLegend)
